import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from '../../../hooks/useTranslation';

/**
 * @param {{ row: object, onEdit: (row: object) => void }} props
 */
const ContractActionsMenu = ({ row, onEdit }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    handleClose();
    onEdit(row);
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleOpen}
        aria-label={t('contracts.actions.openMenu')}
        sx={{ color: '#9e9e9e', '&:hover': { color: '#424242' } }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          paper: {
            elevation: 2,
            sx: { borderRadius: '8px', minWidth: 180, mt: 0.5 },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={handleEdit}
          sx={{ fontSize: '14px', py: 1.2 }}
        >
          {t('contracts.actions.edit')}
        </MenuItem>

        <MenuItem disabled sx={{ fontSize: '14px', py: 1.2 }}>
          {t('contracts.actions.viewStatus')}
        </MenuItem>

        <MenuItem disabled sx={{ fontSize: '14px', py: 1.2 }}>
          {t('contracts.actions.sendEmail')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ContractActionsMenu;
